<template>
	<div class="btn-group" style="margin-top: 0px; margin-left: 4px">
		<button
			type="button"
			class="btn btn-default dropdown-toggle"
			style="padding: 0; border: 0px; background: transparent"
			data-toggle="dropdown"
			aria-haspopup="true"
			aria-expanded="false"
		>
			<span v-show="lg == 'en-en'">
				<img
					src="../../../assets/img/usa.png"
					style="width: 20px; height: 12px; position: relative; top: -1px"
					alt=""
				/>
			</span>
			<span v-show="lg == 'pt-br'">
				<img
					src="../../../assets/img/brasil.png"
					style="width: 20px; height: 12px; position: relative; top: -1px"
					alt=""
				/>
			</span>
			<span v-show="lg == 'es-py'">
				<!-- <img src="../../../assets/img/paraguai.png" style="width: 20px;height: 12px;position: relative;top: -1px;" alt="" /> -->
				<img
					src="../../../assets/img/spain.png"
					style="width: 20px; height: 12px; position: relative; top: -1px"
					alt=""
				/>
			</span>
			<span class="caret"></span>
		</button>
		<ul class="dropdown-menu" style="left: -63px; min-width: 0px">
			<li>
				<a href="#" @click.prevent="_setaLg('en-en')">
					<img
						src="../../../assets/img/usa.png"
						style="width: 20px; position: relative; top: -1px"
						alt=""
					/>
					{{ _traducao('pais', 'eua') }}
				</a>
			</li>
			<li>
				<a href="#" @click.prevent="_setaLg('pt-br')">
					<img
						src="../../../assets/img/brasil.png"
						style="width: 20px; height: 12px; position: relative; top: -2px"
						alt=""
					/>
					{{ _traducao('pais', 'brasil') }}
				</a>
			</li>
			<li>
				<a href="#" @click.prevent="_setaLg('es-py')">
					<!-- <img src="../../../assets/img/paraguai.png" style="width: 20px;height: 12px;position: relative;top: -2px;" alt=""> {{_traducao('pais', 'paraguai')}} -->
					<img
						src="../../../assets/img/spain.png"
						style="width: 20px; height: 12px; position: relative; top: -2px"
						alt=""
					/>
					{{ _traducao('pais', 'paraguai') }}
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	computed: {
		lg() {
			return $sessao.getLang()
		}
	}
}
</script>